var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainHyperlinkInterfaceSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Print"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Mail"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Video"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Film"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Message"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Telephone"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "User"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "File"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Download"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Video_Recorder"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Schedule"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Cart"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Setting"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Pencils"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Record"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Headphone"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Music_Player"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Sound_On"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Sound_Off"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Lock"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Lock_open"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Love"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Favorite"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Film_1_"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Music"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Puzzle"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Turn_Off"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Book"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Save"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Reload"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Trash"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Tag"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,19c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4c1.4-1.4,1.9-3.4,1.3-5.2    c-0.3-0.8-0.7-1.6-1.3-2.2l-5.7-5.7c-1-1-2.3-1.5-3.7-1.5C6.8,3,5.5,3.5,4.5,4.5c-2,2-2,5.3,0,7.4l3.4,3.4c0.4,0.4,0.4,1,0,1.4    c-0.4,0.4-1,0.4-1.4,0l-3.4-3.4c-2.8-2.8-2.8-7.4,0-10.2C4.5,1.8,6.3,1,8.2,1c1.9,0,3.7,0.8,5.1,2.1L19,8.8c0.8,0.8,1.5,1.9,1.8,3    C21.6,14.4,20.9,17.1,19,19z",
    fill: "#FE9803"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.9,28.9c-1.4,1.4-3.2,2.1-5.1,2.1c-1.9,0-3.7-0.8-5.1-2.1L13,23.2c-1.4-1.4-2.1-3.2-2.1-5.1    s0.8-3.7,2.1-5.1c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4c-1,1-1.5,2.3-1.5,3.7c0,1.4,0.6,2.7,1.5,3.7l5.7,5.7    c1,1,2.3,1.5,3.7,1.5c1.4,0,2.7-0.5,3.7-1.5c2-2,2-5.3,0-7.4l-3.4-3.4c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l3.4,3.4    C31.7,21.5,31.7,26.1,28.9,28.9z",
    fill: "#9C27B0"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Like"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Bad"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Gallery"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Add"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Forward"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Back"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Buy"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Mac"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Laptop"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainHyperlinkInterfaceSvgrepoCom);
export default __webpack_public_path__ + "static/media/chain-hyperlink-interface-svgrepo-com.8bab12f36f75e112b5f094031467b4f9.svg";
export { ForwardRef as ReactComponent };